import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const fogoTestnet = {
  displayName: 'Fogo Testnet',
  runtime: 'svm',
  isSupported: false,
  isMainnet: false,
  services: defaultServices(),
} as const satisfies AllChainConfig<'svm', false>;
